export const initNarration = () => {
    const narrateElem = document.querySelector('vapp-narrate')
    if (!narrateElem) return null
    
    if (!narrateElem.hasAttribute('initialized')) {
        narrateElem.setAttribute('initialized', 'true')
        
        if (typeof narrateElem.initializeProvider === 'function') {
            narrateElem.initializeProvider()
        }
    }
    
    return narrateElem
}

export const monitorNarrateElementReadiness = (onReady) => {
    let timer = null
    
    const check = () => {
        const elem = document.querySelector('vapp-narrate')
        if (elem && elem.provider) {
            onReady(elem)
            return true
        }
        return false
    }
    
    if (check()) return { stop: () => {} }
    
    timer = setInterval(() => {
        if (check()) {
            clearInterval(timer)
            timer = null
        }
    }, 100)
    
    return {
        stop: () => {
            if (timer) {
                clearInterval(timer)
                timer = null
            }
        }
    }
}
